// 빈 공간에 값을 채워주는 util
// digit : 적용할 대상
// size : 몇자리로 맞출건지
// attatch : 붙일 문자열
// lPad(2, 3, 0) -> 002 반환
export const lPad = (digit: any, size: any, attatch: any) => {
  const val = digit.toString();
  const str = attatch.toString();
  return str.repeat(Math.max(0, size - val.length)) + val;
};
